import React, { useEffect, useState } from 'react'
import { useForm } from "react-hook-form";
import { 
    clearAll,
    onAddCertificateWHTRate,
    showCertificateFormFunc
 } from '../../../../config/redux/slice/notapUserSlice'
import { useDispatch, useSelector } from 'react-redux';
import { appApi } from '../../../../utils/endpoints/appApi';
import { getRequest, postRequest } from '../../../../helpers/request';
import { onAddCertificate,
        setErrorMessageNotapUser,
        setLoadingNotapUser
 } from '../../../../config/redux/slice/notapUserSlice'
import { Spinner } from '../../../components';
import { getCurrencySymbol, truncateMiddle } from '../../../../helpers/helpers';
import moment from 'moment';

export default function CertificateVerificationUploadForm() {
    const dispatch = useDispatch()
    const {register, handleSubmit, watch, getValues, setError, setValue, formState: {errors}, reset} = useForm({mode: 'onTouched'})
    const [whtRates, setWhtRates] = useState([])
    //  const [amount_available, setRealAmountAvail] = useState("")

    const {
        currencies
    } = useSelector((state) => state.app)

    const {
        notapUserLoading,
        certificateManagement:{certificateDetails}
    } = useSelector((state) => state.notapUser)

    const {
        token,
    } = useSelector((state) => state.authData)


    const closeModal = () => {
        dispatch(clearAll({}))
        dispatch(showCertificateFormFunc({ modal: false }));
    };

    useEffect(()=>{
      getWHTRates()
    }, [])


    const onSubmit = async (data) => {
        dispatch(clearAll({}))
        const res = await postRequest(
            token,
            `${appApi.updateWHTRates}`,
            {...data, certificate_id: certificateDetails.ID},
            dispatch,
            setLoadingNotapUser,
            onAddCertificateWHTRate,
            setErrorMessageNotapUser
        ) 
    }

    const getWHTRates = async () =>{
      const res = await getRequest(
        token,
        `${appApi.getWHTRates}`,
        {},
        dispatch,
        "",
        "",
        ""
      )
      if (res != undefined && res.status < 400){
        setWhtRates(res.data.data)
      }
    }

  return (
    <div 
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >
  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div className="modal-content">
      <form onSubmit={handleSubmit(onSubmit)} autoComplete={'off'} encType='multipart/form-data' noValidate>
        <div className="modal-header px-4">
          <h5 className="modal-title" id="exampleModalCenterTitle">Add WHT Rates</h5>
          <button 
            type="button" 
            className="close" 
            data-dismiss="modal" 
            aria-label="Close"
            onClick={()=>{closeModal()}}
        >
          <span aria-hidden="true">×</span>
        </button>
        </div>
        <div className="modal-body px-4 px-md-7">

          <div className="row mb-2">
            <div className='col-lg-6'>
              <div className="form-group">
                  <label htmlFor='wht_rate'>WHT Rate</label>
                  <select 
                    className="form-control rounded-0" 
                    id="wht_rate"
                    {...register("wht_rate", {
                        required: {
                        value: true,
                        message: '*this field is required'
                        }
                    })
                    } 
                    onChange={(e)=>{
                      let values = (e.target.value).split(',')
                      setValue('wht_rate_id', values[0])
                      setValue('percentage', values[1])
                    }}
                  >
                    <option value={''}>Select rate</option>
                    {whtRates.map((rate, i)=>{
                      return <option key={i} value={`${rate.id},${rate.percentage}`}>{rate.name}</option>
                    })}
                  </select>
                  {
                    errors?.wht_rate?.message &&
                    <div className="text-danger small mt-1">
                        {errors?.wht_rate?.message}
                    </div>
                    }
                </div>
            </div>
          </div>

        </div>
        <div className="modal-footer px-4 d-flex align-items-center">
          <button disabled={notapUserLoading ? true : false} onClick={()=>{reset()}} type="button" className="btn btn-smoke" data-dismiss="modal">Cancel</button>
          <div>
          {notapUserLoading ? 
            <Spinner/> :
            <button type="submit" className="btn btn-primary">Submit</button>
          }
        </div>
        </div>
      </form>
    </div>
  </div>
</div>
  )
}
